/*
 * @Autor: Nehc
 * @Date: 2020-11-26 19:43:44
 * @LastEditors: Nehc
 * @LastEditTime: 2020-11-27 09:51:12
 */
import TablePage from './table.vue';

export default TablePage;
